var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfused({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M53.4,29.9a18.1487,18.1487,0,0,1,1,6.1,17.7021,17.7021,0,0,1-.1,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.7,34.1A18.27,18.27,0,0,1,30,18.6"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 0)",
    d: "M31.2,32a2.4,2.4,0,1,1-2.4-2.4h0A2.4334,2.4334,0,0,1,31.2,32"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 0)",
    d: "M45.6,32a2.4,2.4,0,1,1-2.4-2.4A2.4334,2.4334,0,0,1,45.6,32"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M31.9,15.3a3.4953,3.4953,0,0,0-6.7-1.4,4.46,4.46,0,0,0-6.1,1.7,6.6371,6.6371,0,0,0-.6,2,3.4677,3.4677,0,1,0-2.9,6.3,3.194,3.194,0,0,0,1.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21.9,53.5H18.2a6.1107,6.1107,0,0,1-.5-12.2h0a4.6946,4.6946,0,0,1,4.7-4.7,4.7856,4.7856,0,0,1,4.4,2.9,6.1141,6.1141,0,0,1,7.6,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M53.3,59.9a6.7439,6.7439,0,0,0,6.8-6.8,6.8412,6.8412,0,0,0-6.2-6.8h0A5.3351,5.3351,0,0,0,48.6,41a5.5022,5.5022,0,0,0-4.9,3.2,6.6966,6.6966,0,0,0-9.2,2.5,8.0165,8.0165,0,0,0-.9,3,5.28,5.28,0,0,0-4.4,9.6,5.45,5.45,0,0,0,2.2.5H53.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M38.2,27.1a5.5488,5.5488,0,0,1-5.5-5.5,5.61,5.61,0,0,1,5-5.5h0A4.2682,4.2682,0,0,1,42,11.8a4.1361,4.1361,0,0,1,3.9,2.6,5.432,5.432,0,0,1,8.2,4.5A4.21,4.21,0,0,1,59.7,21a4.2965,4.2965,0,0,1-2.1,5.6,3.9222,3.9222,0,0,1-1.8.4H38.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfused);
export default __webpack_public_path__ + "static/media/Confused.980be727ca8c6c54420a2b39dc592bc6.svg";
export { ForwardRef as ReactComponent };